<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <panel-title v-if="!urunCode" icon="mdi-plus-circle" :title="$t('URUNLER.ADD_NEW_PRODUCT_TITLE')"
                     :desc="$t('URUNLER.ADD_NEW_PRODUCT_SUB_TITLE')" />
        <panel-title v-else icon="mdi-pencil" :title="$t('URUNLER.UPDATE_PRODUCT_TITLE')"
                     :desc="$t('URUNLER.UPDATE_PRODUCT_SUB_TITLE')" />
      </v-col>
    </v-row>
    <v-card class="mb-8 pl-0 pr-0 pr-lg-4">
      <div class="urun-todo-level">
        <v-sheet :color="primaryColor" dark class="rounded-circle px-1 py-1 elevation-1">
          <v-icon size="35">mdi-numeric-1</v-icon>
        </v-sheet>
      </div>
      <v-row no-gutters>
        <v-col cols="12" lg="4" class="d-flex align-center justify-center py-0">
          <v-card width="100%" height="100%" color="white" elevation="0"
                  class="urun-info-main urun-info-box d-flex align-center justify-center px-2 py-2 text-center">
            <div>
              <v-btn small rounded block dark :color="primaryColor" class="d-flex justify-start pl-4 pr-5 mb-3">
                <v-btn fab x-small depressed color="white" light class="mr-2">
                  <v-icon size="25" :color="primaryColor">mdi-numeric-1</v-icon>
                </v-btn>
                <div>{{ $t("URUNLER.ADD_PRODUCT_STEPS.FILL_PRODUCT_INFORMATION") }}</div>
              </v-btn>
              <v-btn small rounded block dark :color="primaryColor" class="d-flex justify-start pl-4 pr-5 mb-3">
                <v-btn fab x-small depressed color="white" light class="mr-2">
                  <v-icon size="25" :color="primaryColor">mdi-numeric-2</v-icon>
                </v-btn>
                <div>{{ $t("URUNLER.ADD_PRODUCT_STEPS.SET_UP_PRODUCT_VARIATIONS") }}</div>
              </v-btn>
              <v-btn small rounded block dark :color="primaryColor" class="d-flex justify-start pl-4 pr-5 mb-3">
                <v-btn fab x-small depressed color="white" light class="mr-2">
                  <v-icon size="25" :color="primaryColor">mdi-numeric-3</v-icon>
                </v-btn>
                <div>{{ $t("URUNLER.ADD_PRODUCT_STEPS.DEFINE_PRODUCT_FEATURES") }}</div>
              </v-btn>
              <v-btn small rounded block dark :color="primaryColor" class="d-flex justify-start pl-4 pr-5 mb-3">
                <v-btn fab x-small depressed color="white" light class="mr-2">
                  <v-icon size="25" :color="primaryColor">mdi-numeric-4</v-icon>
                </v-btn>
                <div>{{ $t("URUNLER.ADD_PRODUCT_STEPS.TYPE_PRODUCT_DESCRIPTION") }}</div>
              </v-btn>
              <v-btn small rounded block dark :color="primaryColorHover" class="d-flex justify-start pl-4 pr-5">
                <v-btn fab x-small depressed color="white" light class="mr-2">
                  <v-icon size="18" :color="primaryColorHover">mdi-check</v-icon>
                </v-btn>
                <div>{{ $t("URUNLER.ADD_PRODUCT_STEPS.PERFORM_PRODUCT_ADDITION") }}</div>
              </v-btn>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" lg="8" class="pa-4">
          <!-- <p class="font-body-2 my-0">
            <v-icon color="black" class="mb-1">mdi-chevron-right</v-icon>Ürün Bilgileri
            <v-divider></v-divider>
          </p>-->
          <v-text-field
            v-model="urunData.urunAdi"
            prepend-icon="mdi-shoe-cleat"
            :label="$t('URUNLER.PRODUCT_INFO_SECTION.PRODUCT_NAME_LABEL')"
            :hint="$t('URUNLER.PRODUCT_INFO_SECTION.PRODUCT_NAME_HINT')"
            class="font-weight-light"
            persistent-hint
          ></v-text-field>
          <v-text-field
            v-model="urunData.urunDesc"
            prepend-icon="mdi-text-box"
            :label="$t('URUNLER.PRODUCT_INFO_SECTION.PRODUCT_DESC_LABEL')"
            :hint="$t('URUNLER.PRODUCT_INFO_SECTION.PRODUCT_DESC_HINT')"
            class="font-weight-light"
            persistent-hint
          ></v-text-field>
          <v-row>
            <v-col cols="12" xl="6" lg="4" sm="12">
              <v-text-field
                v-model="urunData.urunKodu"
                prepend-icon="mdi-qrcode"
                :label="$t('URUNLER.PRODUCT_INFO_SECTION.PRODUCT_CODE_LABEL')"
                :hint="$t('URUNLER.PRODUCT_INFO_SECTION.PRODUCT_CODE_HINT')"
                class="font-weight-light"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xl="6" lg="8" sm="12">
              <v-text-field
                prepend-icon="mdi-link-variant"
                :prefix="webSiteUrl"
                :readonly="linkReadonly"
                v-model="urunData.urunLink"
                :label="$t('URUNLER.PRODUCT_INFO_SECTION.PRODUCT_LINK_LABEL')"
                :hint="$t('URUNLER.PRODUCT_INFO_SECTION.PRODUCT_LINK_HINT')"
                ref="seoLink"
                class="font-weight-light"
              >
                <template v-slot:append-outer class="my-0">
                  <v-tooltip bottom v-if="!editLink">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-on="on" v-bind="attrs" :color="primaryColorHover" fab x-small dark @click="linkEdit">
                        <v-icon>mdi-pen</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("URUNLER.PRODUCT_INFO_SECTION.LINK_EDIT_BTN") }}</span>
                  </v-tooltip>
                  <v-tooltip bottom v-else>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-on="on" v-bind="attrs" color="success" fab x-small dark @click="linkEdit"
                             :loading="editLinkLoading">
                        <v-icon>mdi-check</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("URUNLER.PRODUCT_INFO_SECTION.LINK_EDIT_OK_BTN") }}</span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-select
            prepend-icon="mdi-selection-ellipse-arrow-inside"
            v-model="urunData.urunKategorisi"
            hint
            :items="kategoriListesi"
            item-text="name"
            item-value="code"
            :label="$t('URUNLER.PRODUCT_INFO_SECTION.PRODUCT_CATEGORY_LABEL')"
            persistent-hint
          ></v-select>
        </v-col>
      </v-row>
    </v-card>

    <!-- Ürün Varyasyonları -->
    <div class="mb-10">
      <v-card class="mb-6">
        <div class="urun-todo-level">
          <v-sheet :color="primaryColor" dark class="rounded-circle px-1 py-1 elevation-1">
            <v-icon size="35">mdi-numeric-2</v-icon>
          </v-sheet>
        </div>
        <div class="container px-0 py-0">
          <v-row no-gutters>
            <v-col cols="12" lg="4" class="py-0 order-0">
              <v-card dark class="urun-info-box urun-info-box-variant d-flex justify-center align-center" width="100%"
                      height="100%">
                <h2>
                  <v-icon size="28" left>mdi-chart-gantt</v-icon>
                  {{ $t("URUNLER.VARIATIONS_INFO_SECTION.TITLE") }}
                </h2>
              </v-card>
            </v-col>
            <v-col cols="12" lg="8" class="pa-4 order-2 order-lg-1">
              <v-select
                prepend-inner-icon="mdi-chart-gantt"
                clearable
                :label="$t('URUNLER.VARIATIONS_INFO_SECTION.SINGLE_VARIATION_LABEL')"
                outlined
                hide-details
                :items="urunTurleri"
                item-text="name"
                item-value="code"
                v-model="urunData.urunTuru"
              ></v-select>
            </v-col>
            <v-col v-show="!urunData.urunTuru" cols="12" lg="4" class="order-1 pa-lg-0">
              <v-card elevation="0" color="d-flex justify-center align-center grey lighten-3 px-3 px-lg-15" width="100%"
                      height="100%">
                <p class="text-center mb-0 text-subtitle-2 grey--text" :class="isMobile ? 'py-2' : null">
                  <v-icon size="20" class="mr-1" :color="'grey darken-1'">mdi-information-outline</v-icon>
                  {{ $t("URUNLER.VARIATIONS_INFO_SECTION.SUB_INFO") }}
                </p>
              </v-card>
            </v-col>
            <v-col v-show="!urunData.urunTuru" v-if="urunData.urunVaryasyonlari[0]" cols="12" lg="8"
                   class="pa-4 order-3">
              <v-card dark color="transparent" elevation="0" :style="{ color: primaryColor }" width="100%" class="mb-1">
                <h2 class="text-subtitle-1">
                  <v-icon size="28" left :color="primaryColor">mdi-chart-gantt</v-icon>
                  {{ $t("URUNLER.VARIATIONS_INFO_SECTION.VARIATION_INFORMATIONS") }}
                </h2>
              </v-card>
              <v-divider class="mb-3"></v-divider>
              <v-card v-if="!urunData.urunTuru" color="transparent" elevation="0">
                <div class="d-flex align-center pr-3">
                  <currency-input
                    v-model="urunData.urunVaryasyonlari[0].price"
                    :options="{ currency: 'TRY', currencyDisplay: 'hidden' }"
                    :attrs="{
                      'prepend-inner-icon': 'mdi-currency-try',
                      'hide-details': true,
                      outlined: true,
                      label: !urunData.urunVaryasyonlari[0].discount ? $t('URUNLER.PRICE_TEXT') : $t('URUNLER.DISCOUNTED_PRICE_TEXT'),
                      color: primaryColor
                    }"
                    class="mr-2"
                  >
                    <template v-slot:append>
                      <v-tooltip top :color="!urunData.urunVaryasyonlari[0].discount ? primaryColor : 'red darken-3'">
                        <template #activator="{ on, attrs}">
                          <v-btn
                            v-on="on"
                            v-bind="attrs"
                            class="indirim-btn"
                            fab
                            :color="!urunData.urunVaryasyonlari[0].discount ? primaryColor : 'red darken-3'"
                            dark
                            x-small
                            @click="indirimBelirleKaldir(urunData.urunVaryasyonlari[0].ref)"
                          >
                            <v-icon v-if="!urunData.urunVaryasyonlari[0].discount" size="18">mdi-flash</v-icon>
                            <v-icon v-else size="18">mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <span>{{
                            !urunData.urunVaryasyonlari[0].discount
                              ? $t("URUNLER.VARIATIONS_INFO_SECTION.SET_DISCOUNT")
                              : $t("URUNLER.VARIATIONS_INFO_SECTION.REMOVE_DISCOUNT")
                          }}</span>
                      </v-tooltip>
                    </template>
                  </currency-input>
                  <currency-input
                    v-model="urunData.urunVaryasyonlari[0].oldPrice"
                    v-show="urunData.urunVaryasyonlari[0].discount"
                    ref="urunEskiFiyati"
                    :options="{ currency: 'TRY', currencyDisplay: 'hidden' }"
                    :attrs="{
                      'prepend-inner-icon': 'mdi-currency-try',
                      'hide-details': true,
                      outlined: true,
                      label: $t('URUNLER.OLD_PRICE_TEXT'),
                      color: primaryColor
                    }"
                    class="mr-2"
                  >
                  </currency-input>
                  <v-text-field
                    v-model="urunData.urunVaryasyonlari[0].stock"
                    @keydown="urunData.urunVaryasyonlari[0].stock = filterNumber($event)"
                    hide-details
                    outlined
                    class="mr-4"
                    :label="$t('URUNLER.STOCK_TEXT')"
                    :color="primaryColor"
                    min="0"
                  ></v-text-field>

                  <!-- Varyasyon Resimleri Butonu -->
                  <v-tooltip top :color="primaryColor">
                    <template v-slot:activator="{ on, attrs }">
                      <v-badge
                        offset-x="20"
                        offset-y="20"
                        overlap
                        :value="!!urunData.urunVaryasyonlari[0].images.length"
                        :content="urunData.urunVaryasyonlari[0].images.length"
                        :color="primaryColorHover"
                      >
                        <v-btn
                          v-on="on"
                          v-bind="attrs"
                          :color="primaryColor"
                          dark
                          x-large
                          @click="varyasyonResimDialog(urunData.urunVaryasyonlari[0].ref)"
                          class="text-capitalize"
                          fab
                        >
                          <v-icon size="24">mdi-image-size-select-actual</v-icon>
                        </v-btn>
                      </v-badge>
                    </template>
                    <span>{{ $t("URUNLER.VARIATIONS_INFO_SECTION.PRODUCT_IMAGES_BTN") }}</span>
                  </v-tooltip>
                </div>
              </v-card>
            </v-col>
            <v-col v-if="urunTur" cols="12" class="py-0">
              <div class="px-3 py-3 grey lighten-2">
                <p class="text-subtitle-2 mb-2">
                  {{ $t("URUNLER.VARIATIONS_INFO_SECTION.VARIATION_SUB_INFORMATION") }}
                </p>
                <div class="d-flex">
                  <v-card class="mr-3 rounded-lg" max-width="400" :key="key" v-for="(nitelik, key) in urunTur.attrs">
                    <v-card-title
                      class="mb-2 py-2"
                      :style="{
                        'background-color': secondaryColor,
                        color: primaryColor
                      }"
                    >
                      <p class="text-subtitle-2 fotn-weight-regular mb-0">
                        {{ nitelik.name }}
                      </p>
                    </v-card-title>
                    <v-card-text>
                      <div>
                        <v-chip-group multiple column :color="primaryColor" v-model="urunVaryasyonlar[nitelik.code]"
                                      @change="urunVaryasyonlarSelect">
                          <v-chip filter :key="i" v-for="(item, i) in nitelik.items" :value="item.code">{{ item.name
                            }}
                          </v-chip>
                        </v-chip-group>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card>
      <div v-if="urunData.urunTuru">
        <div class="mb-3">
          <p class="text-body-1 mb-2">
            <v-icon left>mdi-order-bool-ascending-variant</v-icon>
            {{ $t("URUNLER.VARIATIONS_INFO_SECTION.VARIATIONS_TITLE") }}
          </p>
          <v-divider></v-divider>
        </div>
        <p v-if="!urunVaryasyonlari.length" class="text-center text-body-1 grey--text my-5 font-weight-bold">
          {{ $t("URUNLER.VARIATIONS_INFO_SECTION.VARIATIONS_SELECTING_WARN") }}
        </p>
        <v-card v-if="urunVaryasyonlari.length && isVCard()"
                class="variant-card d-flex justify-space-between px-2 py-2 mb-2">
          <div class="mr-3 text-overline d-flex align-center v-card-head-title"
               :style="{ width: vCard1()[0].offsetWidth + 'px' }">
            {{ $t("URUNLER.VARIATIONS_INFO_SECTION.VARITATION_STATUS") }}
          </div>
          <div class="d-flex align-center">
            <div class="row" :style="{ width: vCard2()[0].offsetWidth + 'px' }">
              <div class="col mr-2 text-overline py-0 v-card-head-title" :style="{ 'line-height': 1.5 }" :key="attr"
                   v-for="attr in varyasyonAttrs">
                {{ urunTur.attrs.find(o => o.code === Number(attr)).name }}
              </div>
            </div>
          </div>
          <div class="d-flex align-center text-overline v-card-head-title"
               :style="{ width: vCard3()[0].offsetWidth + 'px' }">
            {{ $t("URUNLER.VARIATIONS_INFO_SECTION.VARIATION_INFORMATIONS_MULTIPLE") }}
          </div>
        </v-card>
        <v-card class="variant-card px-2 py-2 mb-2" :key="key" v-for="(varyasyon, key) in urunData.urunVaryasyonlari">
          <div class="d-flex justify-space-between">
            <!-- V-Card-1 -->
            <div ref="vCard1" class="v-card-1 mr-3">
              <v-switch :color="primaryColor" :disabled="varyasyon.attrs.length == 1" dense hide-details
                        v-model="varyasyon.status" class="variant-status"></v-switch>
            </div>
            <!-- ./V-Card-1 -->

            <!-- V-Card-2 -->
            <div ref="vCard2" class="row v-card-2">
              <div :key="attr" v-for="attr in varyasyon.attrs" class="col mr-2">
                <v-chip label :color="primaryColor" dark class="text-subtitle-2">{{ getTurAttr(attr).name }}</v-chip>
              </div>
            </div>
            <!-- ./V-Card-2 -->

            <!-- V-Card-3 -->
            <div ref="vCard3" class="d-flex justify-space-between align-center v-card-3">
              <currency-input
                v-model="varyasyon.price"
                :key="varyasyon.ref + 1"
                :options="{ currency: 'TRY', currencyDisplay: 'hidden' }"
                :attrs="{
                  'prepend-inner-icon': 'mdi-currency-try',
                  'hide-details': true,
                  class: 'font-weight-light',
                  outlined: true,
                  dense: true,
                  label: !varyasyon.discount ? $t('URUNLER.PRICE_TEXT') : $t('URUNLER.DISCOUNTED_PRICE_TEXT'),
                  color: primaryColor
                }"
                class="mr-2"
              >
                <template v-slot:append>
                  <v-tooltip top :color="!varyasyon.discount ? primaryColor : 'red darken-3'">
                    <template #activator="{ on, attrs}">
                      <v-btn
                        v-on="on"
                        v-bind="attrs"
                        class="indirim-btn"
                        fab
                        :color="!varyasyon.discount ? primaryColor : 'red darken-3'"
                        dark
                        x-small
                        @click="indirimBelirleKaldir(varyasyon.ref)"
                      >
                        <v-icon v-if="!varyasyon.discount" size="18">mdi-flash</v-icon>
                        <v-icon v-else size="18">mdi-close</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ !varyasyon.discount ? $t("URUNLER.VARIATIONS_INFO_SECTION.SET_DISCOUNT") : $t("URUNLER.VARIATIONS_INFO_SECTION.REMOVE_DISCOUNT")
                      }}</span>
                  </v-tooltip>
                </template>
              </currency-input>
              <currency-input
                v-model="varyasyon.oldPrice"
                v-show="varyasyon.discount"
                :key="varyasyon.ref + 2"
                ref="urunEskiFiyati"
                :options="{ currency: 'TRY', currencyDisplay: 'hidden' }"
                :attrs="{
                  'prepend-inner-icon': 'mdi-currency-try',
                  'hide-details': true,
                  class: 'font-weight-light',
                  outlined: true,
                  dense: true,
                  label: $t('URUNLER.OLD_PRICE_TEXT'),
                  color: primaryColor
                }"
                class="mr-2"
              >
              </currency-input>
              <v-text-field
                v-model="varyasyon.stock"
                @keydown="varyasyon.stock = filterNumber($event)"
                hide-details
                outlined
                dense
                class="font-weight-light mr-2"
                :label="$t('URUNLER.STOCK_TEXT')"
                :color="primaryColor"
              ></v-text-field>

              <!-- Varyasyon Resimleri Butonu -->
              <v-tooltip top :color="primaryColor">
                <template v-slot:activator="{ on, attrs }">
                  <v-badge offset-x="28" offset-y="15" overlap :value="!!varyasyon.images.length"
                           :content="varyasyon.images.length" :color="primaryColorHover">
                    <v-btn v-on="on" v-bind="attrs" :color="primaryColor" text
                           @click="varyasyonResimDialog(varyasyon.ref)">
                      <v-icon>mdi-image-size-select-actual</v-icon>
                    </v-btn>
                  </v-badge>
                </template>
                <span>{{ $t("URUNLER.VARIATIONS_INFO_SECTION.PRODUCT_IMAGES_BTN") }}</span>
              </v-tooltip>
              <!-- ./Varyasyon Resimleri Butonu -->
            </div>
            <!-- ./V-Card-3 -->
          </div>
        </v-card>
      </div>
    </div>
    <!-- ./Ürün Varyasyonları -->

    <!-- Ürün Özellikleri -->
    <v-card class="mb-10">
      <div class="urun-todo-level">
        <v-sheet :color="primaryColor" dark class="rounded-circle px-1 py-1 elevation-1">
          <v-icon size="35">mdi-numeric-3</v-icon>
        </v-sheet>
      </div>
      <v-container class="px-0 py-0">
        <v-row no-gutters>
          <v-col cols="12" lg="4" class="py-0">
            <v-sheet height="100%" class="grey lighten-3" :min-height="isDesktop ? '242px' : null">
              <v-card dark class="urun-info-box urun-info-box-variant d-flex justify-center align-center" width="100%"
                      height="80">
                <h2>
                  <v-icon size="28" left>mdi-feather</v-icon>
                  {{ $t("URUNLER.PRODUCT_FEATURES_SECTION.TITLE") }}
                </h2>
              </v-card>
              <v-sheet class="d-flex justify-center align-center px-3 px-lg-15" color="transparent"
                       height="calc(100% - 80px)">
                <p class="text-center mb-0 text-subtitle-2 grey--text" :class="isMobile ? 'py-2' : null">
                  <v-icon size="20" class="mr-1" :color="'grey darken-1'">mdi-information-outline</v-icon>
                  {{ $t("URUNLER.PRODUCT_FEATURES_SECTION.SUB_INFO") }}
                </p>
              </v-sheet>
            </v-sheet>
          </v-col>
          <v-col cols="12" lg="8" class="pa-4">
            <v-autocomplete
              prepend-inner-icon="mdi-feather"
              outlined
              hide-details
              :label="$t('URUNLER.PRODUCT_FEATURES_SECTION.ADD_FEATURE_LABEL')"
              :search-input.sync="ozellikAutoCMP.search"
              :loading="ozellikAutoCMP.loading"
              :items="ozellikAutoCMP.items"
              item-text="name"
              item-value="code"
              v-model="ozellikAutoCMP.value"
              :no-data-text="$t('URUNLER.PRODUCT_FEATURES_SECTION.ADD_FEATURE_HINT')"
              multiple
              return-object
            ></v-autocomplete>
            <v-divider class="my-3"></v-divider>
            <div v-if="urunData.urunOzellikleri.length" class="d-flex">
              <v-badge overlap offset-x="55" offset-y="10" color="transparent" :key="key"
                       v-for="(ozellik, key) in urunData.urunOzellikleri">
                <template #badge>
                  <v-tooltip top :color="primaryColorHover">
                    <template #activator="{ on, attrs }">
                      <v-btn v-on="on" v-bind="attrs" icon x-small color="white"
                             :style="{ 'background-color': primaryColorHover }" class="mr-1">
                        <v-icon dark size="15">mdi-information-variant</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ ozellik.desc || $t("URUNLER.PRODUCT_FEATURES_SECTION.NO_DESCRIPTION_INFO") }}</span>
                  </v-tooltip>
                  <v-btn @click="urunOzellikKaldir(ozellik.field)" icon x-small color="white"
                         :style="{ 'background-color': primaryColorHover }">
                    <v-icon dark size="15">mdi-close</v-icon>
                  </v-btn>
                </template>
                <v-card class="d-flex align-center pr-2 mr-3 mb-3" :color="primaryColor" dark max-width="200">
                  <span class="px-3">{{ ozellik.name }}</span>
                  <v-text-field
                    v-model="ozellik.value"
                    outlined
                    dense
                    hide-details
                    :color="secondaryColor"
                    :placeholder="$t('URUNLER.PRODUCT_FEATURES_SECTION.FEATURE_TYPE_PLACEHOLDER')"
                  ></v-text-field>
                </v-card>
              </v-badge>
            </div>
            <div v-else>
              <p class="text-center text-subtitle-2 py-7 grey lighten-3 grey--text text--darken-1">
                {{ $t("URUNLER.PRODUCT_FEATURES_SECTION.NO_FEATURE_ADDITIONAL") }}
              </p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <!-- ./Ürün Özellikleri -->

    <!-- Ürün Açıklaması -->
    <v-card class="mb-8">
      <div class="urun-todo-level">
        <v-sheet :color="primaryColor" dark class="rounded-circle px-1 py-1 elevation-1">
          <v-icon size="35">mdi-numeric-4</v-icon>
        </v-sheet>
      </div>
      <v-container class="px-0 py-0">
        <v-row no-gutters>
          <v-col cols="12" lg="4" class="py-0">
            <v-sheet height="100%" class="grey lighten-3" :min-height="isDesktop ? '242px' : null">
              <v-card dark class="urun-info-box urun-info-box-variant d-flex justify-center align-center" width="100%"
                      height="80">
                <h2>
                  <v-icon size="28" left>mdi-text</v-icon>
                  {{ $t("URUNLER.PRODUCT_DESCRIPTION_SECTION.TITLE") }}
                </h2>
              </v-card>
              <v-sheet class="d-flex justify-center align-center px-3 px-lg-15" color="transparent"
                       :height="isDesktop ? 'calc(100% - 80px)' : null">
                <p class="text-center mb-0 text-subtitle-2 grey--text" :class="isMobile ? 'py-2' : null">
                  <v-icon size="20" class="mr-1" :color="'grey darken-1'">mdi-information-outline</v-icon>
                  {{ $t("URUNLER.PRODUCT_DESCRIPTION_SECTION.SUB_INFO") }}
                </p>
              </v-sheet>
            </v-sheet>
          </v-col>
          <v-col cols="12" lg="8" class="pa-4">
            <aciklama-editor
              v-model="urunData.urunAciklamasi"
              :set-content="urunSetEditorContent"
              :editor-base-color="primaryColor"
              :editor-selecting-color="primaryColorHover"
              editor-passive-color="indigo lighten-5"
              editor-border-color="#7986CB"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <!-- ./Ürün Açıklaması -->

    <v-container>
      <v-row>
        <v-col cols="12" class="d-flex justify-end align-center px-0 py-0 grey lighten-2">
          <v-card class="d-flex align-center justify-end flex-wrap px-2 py-2" elevation="0" color="transparent"
                  width="100%">
            <v-card elevation="0" class="d-flex justify-end align-center flex-grow-1 px-4 py-2 mr-sm-5 mb-2 mb-sm-0">
              <div :style="{ color: primaryColor }" class="text-subtitle-2 mr-2">
                <span>{{ $t("URUNLER.PRODUCT_ACTIONS_SECTION.PUBLISH_PRODUCT_NOW") }}</span>
              </div>
              <v-switch v-model="urunData.urunDurumu" hide-details color="success" class="mt-0 pt-0"></v-switch>
            </v-card>
            <div>
              <v-btn color="error" class="mr-2" @click="router.push('/panel/urunler/urun-listesi')">
                <v-icon>mdi-plus</v-icon>
                {{ $t("URUNLER.PRODUCT_ACTIONS_SECTION.CANCEL_BTN") }}
              </v-btn>
              <v-btn v-if="!urunDetay" color="success" @click="yeniUrunEkle" :loading="urunActionStatus">
                <v-icon>mdi-plus</v-icon>
                {{ $t("URUNLER.PRODUCT_ACTIONS_SECTION.ADD_PRODUCT_BTN") }}
              </v-btn>
              <v-btn v-else color="success" @click="urunDuzenle" :loading="urunActionStatus">
                <v-icon>mdi-refresh</v-icon>
                {{ $t("URUNLER.PRODUCT_ACTIONS_SECTION.UPDATE_PRODUCT_BTN") }}
              </v-btn>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Ürün resim düzenle dialog -->
    <v-dialog max-width="1050" v-model="urunResimleri.dialog" scrollable>
      <v-card>
        <v-card-title class="white--text mb-4" :style="{ 'background-color': primaryColor }">
          <v-icon dark left>mdi-image</v-icon>
          <span class="text-subtitle-1">{{ $t("URUNLER.PROUCT_IMAGES_DIALOG.TITLE") }}</span>
          <v-spacer></v-spacer>
          <v-btn icon dark small @click="urunResimleri.dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <resim-ekle
            v-if="urunResimleri.images"
            :buttonstyle="{ 'background-color': primaryColor, color: 'white' }"
            v-model="urunResimleri.images"
            @input="setVaryasyonImages"
          />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="success" @click="urunResimleri.dialog = false">
            <v-icon left>mdi-check</v-icon>
            {{ $t("URUNLER.PROUCT_IMAGES_DIALOG.OK_BTN") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ./Ürün resim düzenle dialog -->
  </v-container>
</template>

<script>
import PanelTitle from "../../../components/PanelTitle.vue";
import { mapState } from "vuex";
import UrunlerService from "@/services/UrunlerService.js";
import CurrencyInput from "../../../components/Modules/Urunler/CurrencyInput.vue";
import ResimEkle from "../../../components/Modules/Urunler/ResimEkle.vue";
import CheetahEditor from "../../../components/CheetahEditor.vue";
import RouterService from "@/services/RouterService.js";
import AciklamaEditor from "../../../components/Modules/Urunler/AciklamaEditor.vue";
import { reactive } from "@vue/composition-api";

export default {
  components: {
    PanelTitle,
    CurrencyInput,
    ResimEkle,
    CheetahEditor,
    AciklamaEditor
  },
  name: "UrunEkle",
  inject: ["webSiteUrl"],
  data: () => ({
    // Düzenleme için urunCode
    urunCode: null,
    // Düzenleme ürün detayı
    urunDetay: null,
    primaryColor: "#4158d0",
    primaryColorHover: "#2d43b4",
    secondaryColor: "#f9bf03",
    // urunData: {
    //   urunAdi: "",
    //   urunKodu: "",
    //   urunLink: "",
    //   urunKategorisi: "",
    //   urunTuru: "",
    //   urunVaryasyonlari: [],
    //   urunOzellikleri: [],
    //   urunAciklamasi: "",
    //   urunDurumu: true
    // },
    ozellikAutoCMP: {
      search: "",
      loading: false,
      timeout: null,
      items: [],
      value: [],
      values: []
    },
    // Ürün türü seçimi yapıldığında alınan data
    urunTur: null,
    // "UrunTur" attrs
    urunTurAttrs: null,
    // Varyasyon eklemelerinde nitelik code'ları
    // "varyasyonAttrs"'a girilir
    varyasyonAttrs: null,
    urunVaryasyonlar: {},
    // Ürün türleri listesi
    urunTurleri: [],
    // Seçilen tüm varyasyon nitelik değerleri grubu
    currentAttrGroups: {},
    urunResimleri: {
      ref: "",
      dialog: false,
      images: null
    },
    tekUrun: {
      discount: false,
      oldPrice: "",
      purchasePrice: "",
      price: "",
      stock: "",
      images: [],
      status: true,
      ref: "0",
      attrs: []
    },
    urunSetEditorContent: "",
    urunActionStatus: false,
    number: null,
    editLink: false,
    editLinkLoading: false,
    linkReadonly: true,
    baslikTimeout: "",
    baslikSeoLinkTimeout: 650,
    urunTuruPromise: null,
    pageLoaded: false,
    // Düzenleme olduğunda detay verisi ekleme sürecinin
    // tamamlanıp tamamlanmadığını bildirir
    editStatus: false,
    lastId: 0
  }),

  setup() {
    const urunData = reactive({
      urunAdi: "",
      urunDesc: "",
      urunKodu: "",
      urunLink: "",
      urunKategorisi: "",
      urunTuru: "",
      urunVaryasyonlari: [],
      urunOzellikleri: [],
      urunAciklamasi: "",
      urunDurumu: true
    });

    function selectVariation(variation) {

    }

    return {
      urunData
    };
  },

  computed: {
    ...mapState({
      kategoriListesi: state => state.Urunler.UrunCategories.kategoriListesi
    }),
    /**
     * @returns {Object}
     */
    router() {
      return this.$router;
    },
    /**
     * @returns {Array}
     */
    urunVaryasyonlari() {
      return this.urunData.urunVaryasyonlari;
    },
    isDesktop() {
      return this.$vuetify.breakpoint.lgAndUp;
    },
    isMobile() {
      return this.$vuetify.breakpoint.mdAndDown;
    }
  },
  methods: {
    yeniUrunEkle() {
      let {
        urunAdi,
        urunDesc,
        urunKodu,
        urunLink,
        urunKategorisi,
        urunTuru,
        urunVaryasyonlari,
        urunOzellikleri,
        urunAciklamasi,
        urunDurumu
      } = this.urunData;

      this.urunData.urunVaryasyonlari.map(o => {
        if (o.price == null) {
          o.price = "";
        }
        if (o.oldPrice == null) {
          o.oldPrice = "";
        }
        if (o.purchasePrice == null) {
          o.purchasePrice = "";
        }
        if (!o.attrs) {
          o.attrs = [];
        }
      });

      this.urunActionStatus = true;
      UrunlerService.urunEkle({
        urunAdi,
        urunDesc,
        urunKodu,
        urunLink,
        urunKategorisi,
        urunTuru,
        urunVaryasyonlari,
        urunOzellikleri,
        urunAciklamasi,
        urunDurumu: urunDurumu ? 1 : 0
      })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success("Ürün başarılı bir eklenmiştir", this.$t("PANEL.NOTIFY.SUCCESS"));
            this.$router.push("/panel/urunler/urun-listesi");
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.urunActionStatus = false;
        });
    },
    urunDuzenle() {
      let {
        urunAdi,
        urunDesc,
        urunKodu,
        urunLink,
        urunKategorisi,
        urunTuru,
        urunVaryasyonlari,
        urunOzellikleri,
        urunAciklamasi,
        urunDurumu
      } = this.urunData;

      const urunCode = this.urunCode;

      this.urunData.urunVaryasyonlari.map(o => {
        if (o.price == null) {
          o.price = "";
        }
        if (o.oldPrice == null) {
          o.oldPrice = "";
        }
        if (o.purchasePrice == null) {
          o.purchasePrice = "";
        }
        if (!o.attrs) {
          o.attrs = [];
        }
      });

      this.urunActionStatus = true;
      UrunlerService.urunDuzenle({
        urunCode,
        urunAdi,
        urunDesc,
        urunKodu,
        urunLink,
        urunKategorisi,
        urunTuru,
        urunVaryasyonlari,
        urunOzellikleri,
        urunAciklamasi,
        urunDurumu: urunDurumu ? 1 : 0
      })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success("Ürün başarılı bir güncellenmiştir", this.$t("PANEL.NOTIFY.SUCCESS"));
            this.$router.push("/panel/urunler/urun-listesi");
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.urunActionStatus = false;
        });
    },
    setUrunDetay() {
      // Düzenleme olup olmadığını kontrol et
      if (this.urunCode && !this.editStatus) {
        let ud = this.urunData,
          d = this.urunDetay;

        ud.urunAdi = d.name;
        ud.urunDesc = d.desc;
        ud.urunKodu = d.kod;
        ud.urunLink = d.link;
        ud.urunDurumu = !!d.publish;
        ud.urunKategorisi = d.category;
        ud.urunVaryasyonlari = JSON.parse(JSON.stringify(d.varyasyonlar));

        d.varyasyonlar.forEach((v, i) => {
          const attrs = v.attrs.map(Number);
          const ref = this.arrayToHashKey(attrs);
          this.$set(this.urunData.urunVaryasyonlari[i], "status", !!this.urunData.urunVaryasyonlari[i].status)
          this.$set(this.urunData.urunVaryasyonlari[i], "discount", !!this.urunData.urunVaryasyonlari[i].discount)
          this.$set(this.urunData.urunVaryasyonlari[i], "ref", ref)

          let convertedImages = [],
            vImages = this.urunData.urunVaryasyonlari[i].images;

          // Varyasyon resimlerini derle
          vImages.forEach(element => {
            convertedImages.push(this.convertToBase64(element));
          });

          Promise.all(convertedImages)
            .then(b64Url => {
              let images = [];
              b64Url.forEach((url, index) => {
                images.push({
                  id: this.getLastID() + 1,
                  name: vImages[index]?.match(/\/([^\/]+)$/)[1],
                  url: url,
                  origin: vImages[index],
                  uploaded: true
                });
              });
              return images;
            })
            .then(images => {
              this.urunData.urunVaryasyonlari[i].images = images;
            });

          this.$set(this.currentAttrGroups, ref, attrs);
        });

        if (d.varyasyonAttrs.length) {
          this.varyasyonAttrs = d.varyasyonAttrs;
        }

        // if (d.currentAttrs.length) {
        // }

        if (d.varyasyonMap.length === undefined) {
          this.urunVaryasyonlar = d.varyasyonMap;
        }

        ud.urunOzellikleri = d.ozellikler;
        ud.urunAciklamasi = d.aciklama;
        this.urunSetEditorContent = d.aciklama;

        this.editStatus = true;
      }
    },
    filterNumber(e) {
      e.preventDefault();

      let key = e.key,
        val = Number(key.match(/\d+/g, "")),
        currentVal = val ? val : "",
        value = e.target.value;

      if (key == "Backspace") {
        return value.substr(0, value.length - 1);
      }

      if (key == "0" && value != "0") currentVal = "0";

      let newValue = value + currentVal;

      return value != "0" ? newValue : value;
    },
    vCard1() {
      return this.$refs.vCard1;
    },
    vCard2() {
      return this.$refs.vCard2;
    },
    vCard3() {
      return this.$refs.vCard3;
    },
    isVCard() {
      if (this.vCard1()?.length) {
        return true;
      } else {
        return false;
      }
    },
    getTurAttr(attrValueCode) {
      return this.urunTurAttrs[attrValueCode];
    },
    varyasyonResimDialog(ref) {
      this.urunResimleri.ref = ref;
      this.urunResimleri.dialog = true;
      this.urunResimleri.images = this.urunData.urunVaryasyonlari.find(o => o.ref === ref).images;
    },
    setVaryasyonImages(data) {
      const varyasyon = this.urunData.urunVaryasyonlari.find(o => o.ref === this.urunResimleri.ref);
      varyasyon.images = data;
    },
    urunTuruDetay(turCode) {
      return UrunlerService.urunTuruDetay(turCode).then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          this.$snotify(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          this.urunData.urunTuru = undefined;
        }
      });
    },
    indirimBelirleKaldir(ref) {
      let varyasyon = this.urunData.urunVaryasyonlari.find(o => o.ref == ref);
      varyasyon.discount = !varyasyon.discount;
      if (!varyasyon.discount) {
        varyasyon.oldPrice = "";
      }
    },
    urunOzellikKaldir(ozellikCode) {
      this.urunData.urunOzellikleri = this.urunData.urunOzellikleri.filter(o => o.field != ozellikCode);
    },
    linkEdit() {
      this.$refs.seoLink.$el.querySelector("input").focus();
      if (this.editLink) {
        this.linkReadonly = true;
        this.checkLink(this.urunData.urunLink).then(() => (this.editLink = false));
      } else {
        this.linkReadonly = false;
        this.editLink = true;
      }
    },
    checkLink(link) {
      this.editLinkLoading = true;

      /**
       * Veri güncelleme verisi ise link'i ona göre getir
       */
      let seoUrlMethod = "seoUrl",
        update = null;
      if (this.urunCode) {
        seoUrlMethod = "seoUpdateUrl";
        update = link;
        link = this.urunData.urunLink;
      }

      return new Promise(resolve => {
        RouterService[seoUrlMethod]({ link, update }).then(res => {
          this.editLinkLoading = false;
          if (res.status === 200) {
            this.urunData.urunLink = res.data;
          }
          resolve(res);
        });
      });
    },
    cartesian(...args) {
      var r = [],
        max = args.length - 1;

      function helper(arr, i) {
        for (var j = 0, l = args[i].length; j < l; j++) {
          var a = arr.slice(0); // clone arr
          a.push(args[i][j]);
          if (i == max) r.push(a);
          else helper(a, i + 1);
        }
      }

      helper([], 0);
      return r;
    },
    shallowEqual(array1, array2) {
      if (array1.length !== array2.length) {
        return false;
      }

      for (let key of array1) {
        if (object1[key] !== object2[key]) {
          return false;
        }
      }

      return true;
    },
    convertToBase64(image) {
      return new Promise(resolve => {
        let picReader = new FileReader();
        picReader.onload = image => resolve(image.target.result);
        fetch(image)
          .then(res => res.blob())
          .then(blob => {
            picReader.readAsDataURL(blob);
          });
      });
    },
    /**
     * Kayıtlı son id'yi al
     */
    getLastID() {
      return (this.lastId = ++this.lastId);
    },

    arraysHaveSameElements(arr1, arr2) {
      if (arr1.length !== arr2.length) return false;

      const sorted1 = [...arr1].sort((a, b) => a - b);
      const sorted2 = [...arr2].sort((a, b) => a - b);

      return sorted1.every((val, index) => val === sorted2[index]);
    },

    arrayToHashKey(arr) {
      return [...arr].sort((a, b) => a - b).join('-');
    },
    /**
     * Varyasyonlar her değiştiğinde kartezyen hesaplaması
     * ile yenilemeler yapılır
     */
    urunVaryasyonlarSelect() {
      const value = this.urunVaryasyonlar;
      let valueKeys = Object.keys(value);

      // Güncel nitelik başlık code'larını al
      this.varyasyonAttrs = valueKeys.filter(o => value[o].length > 0);

      // Varyasyonlar boş ise temizle
      if (this.varyasyonAttrs.length === 0) {
        this.$set(this.urunData, "urunVaryasyonlari", []);
        this.currentAttrGroups = {};
        return;
      }

      const turAttrsCodeList = this.urunTur.attrs.map(o => o.code);

      // mevcut niteliklerin detay code'larını referans alarak
      // seçim yapılan niteliklerin değerlerini sırala
      const attrValues = [];
      turAttrsCodeList.forEach(code => {
        if (valueKeys.includes(String(code))) {
          attrValues.push(value[code]);
        }
      });

      // Nitelik değerleri code'larını al
      // Ardından kartezyen hesaplamasından geçir
      let attrsArray = attrValues.filter(o => o.length > 0),
        attrs = this.cartesian(...attrsArray),
        variants = [];

      // Varyasyonları oluştur
      attrs.forEach(attr => {
        let ref = this.arrayToHashKey(attr);

        if (!this.arraysHaveSameElements(attr, this.currentAttrGroups[ref] || [])) {
          variants.push({
            discount: false,
            oldPrice: "",
            purchasePrice: "",
            price: "",
            stock: "",
            images: [],
            status: true,
            attrs: attr,
            ref: ref || "0"
          });

          // Nitelik değeri referans gruplarını ekle
          this.$set(this.currentAttrGroups, ref, attr);
        } else {
          variants.push(this.urunData.urunVaryasyonlari.find(o => o.ref === ref));
        }
      });

      /**
       * Baryasyon silinmiş olabilir o zaman tümü oluşturulduktan sonra silinmiş olan varyasonu
       * ref üzerinden bul ve tüm izlerini yok et
       * @type {*[]}
       */
      const allRefs = this.urunData.urunVaryasyonlari.map(v => v.ref);
      allRefs.forEach(ref => {
        const usedRefs = attrs.map(attr => this.arrayToHashKey(attr));

        if (!usedRefs.includes(ref)) {
          this.$delete(this.currentAttrGroups, ref);
          const index = this.urunData.urunVaryasyonlari.findIndex(v => v.ref === ref);
          if (index !== -1) {
            this.urunData.urunVaryasyonlari.splice(index, 1);
          }
        }
      })

      // Varyasyonları ekle
      this.$set(this.urunData, "urunVaryasyonlari", variants);
    }
  },
  created() {
    // Ürün kategoriler listesini getir
    this.$store.dispatch("Urunler/UrunCategories/kategoriListesi");
    // Ürün türleri listesini getir
    UrunlerService.urunTuruListesi().then(res => {
      if (res.status === 200) {
        this.urunTurleri = res.data;
      } else {
        this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
        this.$router.back();
      }
    });
  },
  mounted() {
    // İşlem ürün güncelleme işlemi mi ?
    this.urunCode = Number(this.$route.params.urunCode);
    if (this.urunCode) {
      UrunlerService.urunDetay(this.urunCode).then(res => {
        if (res.status == 200) {
          // Güncelleme verisini al
          this.urunDetay = res.data;
          // Güncelleme verisini aktarma tetiklemesi
          if (this.urunDetay.type > 0) {
            this.urunData.urunTuru = this.urunDetay.type;
          } else {
            this.setUrunDetay();
          }
        } else {
          this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          this.$router.back();
        }
      });
    }
  },
  watch: {
    /**
     * Başlık değiştiğinde seo link üret
     */
    "urunData.urunAdi"(value) {
      if (this.baslikTimeout) {
        clearTimeout(this.baslikTimeout);
      }

      this.baslikTimeout = setTimeout(() => {
        this.checkLink(value);
      }, this.baslikSeoLinkTimeout);
    },
    /**
     * Ürün türü seçimi yapıldığında ürün türü nesnesini
     * bir değere atar
     */
    "urunData.urunTuru": {
      handler(turCode) {
        if (!turCode) {
          this.urunData.urunVaryasyonlari = [JSON.parse(JSON.stringify(this.tekUrun))];
          this.urunTur = null;
          this.urunData.urunTuru = 0;
          return;
        } else {
          this.urunData.urunVaryasyonlari = [];
        }

        this.urunTuruPromise = this.urunTuruDetay(turCode)
          .then(data => {
            return (this.urunTur = data);
          })
          .then(data => {
            /**
             * Ürün türü değişikliklerinde sağlanan türe ait tüm
             * nitelikleri bir diziye atar
             * [{nitelikCode: {Object: Nitelik}}]
             */
            if (!data) return;

            let attrs = {};
            // const getAttrCodes = () => attrs
            for (let i = 0; i < data.attrs.length; i++) {
              data.attrs[i].items.forEach(attrVal => {
                attrs[attrVal.code] = attrVal;
              });
            }

            return (this.urunTurAttrs = attrs);
          })
          .then(() => {
            this.urunVaryasyonlar = {};
          })
          // Detay verisi var ise insert et
          .then(() => this.setUrunDetay());
      },
      immediate: true
    },
    /**
     * Ürün özellikleri araması yapar
     */
    "ozellikAutoCMP.search": {
      handler(value) {
        if (!value) return;

        const ara = value;
        if (this.ozellikAutoCMP.timeout) {
          clearTimeout(this.ozellikAutoCMP.timeout);
        }

        this.ozellikAutoCMP.timeout = setTimeout(() => {
          this.ozellikAutoCMP.loading = true;
          UrunlerService.ozellikAra({ ara })
            .then(res => {
              if (res.status === 200) {
                this.ozellikAutoCMP.items = res.data;
              }
            })
            .then(() => {
              this.ozellikAutoCMP.loading = false;
              clearTimeout(this.ozellikAutoCMP.timeout);
            });
        }, 350);
      },
      deep: true
    },
    "ozellikAutoCMP.value": {
      handler(value) {
        if (!value.length) return;
        this.ozellikAutoCMP.values = value.map(o => o.code);
        let currentValues = this.urunData.urunOzellikleri.map(o => o.field);

        value.forEach(item => {
          if (!currentValues.includes(item.code)) {
            this.urunData.urunOzellikleri.push({
              name: item.name,
              desc: item.desc,
              value: "",
              field: item.code
            });
          }
        });

        this.ozellikAutoCMP.value = [];
        this.ozellikAutoCMP.items = [];
      },
      deep: true
    },
    "urunData.urunKategorisi": {
      handler(value) {
        if (!value) {
          this.urunData.urunKategorisi = 0;
        }
      },
      immediate: true
    }
  }
};
</script>

<style>
.pr-text-gradient {
  font-size: 72px;
  background: -webkit-linear-gradient(90deg, #4158d0, #c850c0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.urun-info-content {
  position: relative;
}

.urun-info-content h2 {
  color: #4158d0;
  padding-bottom: 0;
  margin-bottom: 10px !important;
  border-bottom: 1px solid #4158d0;
  font-weight: 500;
}

.urun-info-content p {
  line-height: 1.3em !important;
  font-size: 14px !important;
  margin-bottom: 5px;
}

.urun-info-box {
  background-size: 70%;
  background-position: center;
  position: relative;
}

.urun-info-box:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: rgb(249 191 3 / 90%);
}

.urun-info-main {
  background-image: url("https://cdn-icons.flaticon.com/png/512/4057/premium/4057156.png?token=exp=1635163938~hmac=b9bfe7290a6700bbc88131d210e89c05");
}

.urun-todo-level {
  position: absolute;
  right: -15px;
  top: -15px;
  z-index: 1;
}

.urun-info-box-variant::before {
  background-color: #4158d0;
}

.urun-info-box-variant-2 {
  background-color: #f9bf03;
}

.urun-info-box > * {
  position: relative;
}

.variant-card .v-card-2 {
  flex-basis: 90%;
}

.variant-card .v-card-1 {
  flex-basis: 5%;
}

.variant-status {
  position: relative;
  top: -7px;
}

.v-card-head-title.text-overline {
  font-size: 10px !important;
}

.indirim-btn {
  top: -4px;
}
</style>
